// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Char91indexChar93RouteImport } from './routes/[index]'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AppRouteImport } from './routes/_app'
import { Route as OwnerRouteImport } from './routes/_owner'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CollaboratorAcceptRouteImport } from './routes/collaborator-accept'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CrmSansAbonnementRouteImport } from './routes/crm-sans-abonnement'
import { Route as CrmTpeParisRouteImport } from './routes/crm-tpe-paris'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PaymentSuccessRouteImport } from './routes/payment-success'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as UseCasesRouteImport } from './routes/use-cases'
import { Route as Char91indexHtmlChar93RouteImport } from './routes/[index.html]'
import { Route as AppAgentAuditRouteImport } from './routes/_app/agent-audit'
import { Route as AppAgentMetricsRouteImport } from './routes/_app/agent-metrics'
import { Route as AppAutoSearchRouteImport } from './routes/_app/auto-search'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppChatRouteImport } from './routes/_app/chat'
import { Route as AppChecklistsRouteImport } from './routes/_app/checklists'
import { Route as AppContactsRouteImport } from './routes/_app/contacts'
import { Route as AppContentRouteImport } from './routes/_app/content'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppEmailsRouteImport } from './routes/_app/emails'
import { Route as AppEventsRouteImport } from './routes/_app/events'
import { Route as AppLinkedinHistoryRouteImport } from './routes/_app/linkedin-history'
import { Route as AppMyTasksRouteImport } from './routes/_app/my-tasks'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppPersonSearchRouteImport } from './routes/_app/person-search'
import { Route as AppReceiptsRouteImport } from './routes/_app/receipts'
import { Route as AppRulesRouteImport } from './routes/_app/rules'
import { Route as AppScheduledEmailsRouteImport } from './routes/_app/scheduled-emails'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as AppSubscriptionRouteImport } from './routes/_app/subscription'
import { Route as AppTemplatesRouteImport } from './routes/_app/templates'
import { Route as AppVeilleRouteImport } from './routes/_app/veille'
import { Route as AppWellbeingRouteImport } from './routes/_app/wellbeing'
import { Route as AppWhatsNewRouteImport } from './routes/_app/whats-new'
import { Route as AppWhatsappHistoryRouteImport } from './routes/_app/whatsapp-history'
import { Route as BookTokenRouteImport } from './routes/book.$token'
import { Route as ComparaisonsIndexRouteImport } from './routes/comparaisons.index'
import { Route as ComparaisonsSlugRouteImport } from './routes/comparaisons.$slug'
import { Route as DevResponsiveListsRouteImport } from './routes/dev.responsive-lists'
import { Route as DocsIndexRouteImport } from './routes/docs.index'
import { Route as DocsRgpdObligationsRouteImport } from './routes/docs.rgpd-obligations'
import { Route as EventCheckinCoachIdRouteImport } from './routes/event-checkin.$coachId'
import { Route as OauthAmazonRouteImport } from './routes/oauth.amazon'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as ProspectFormCoachIdRouteImport } from './routes/prospect-form.$coachId'
import { Route as SecurityIndexRouteImport } from './routes/security.index'
import { Route as SecurityAiPolicyRouteImport } from './routes/security.ai-policy'
import { Route as SecurityAiiaRouteImport } from './routes/security.aiia'
import { Route as SecurityIncidentProcedureRouteImport } from './routes/security.incident-procedure'
import { Route as SecurityPolicyRouteImport } from './routes/security.policy'
import { Route as SecuritySubprocessorsRouteImport } from './routes/security.subprocessors'
import { Route as SharedTokenRouteImport } from './routes/shared.$token'
import { Route as TransferTokenRouteImport } from './routes/transfer.$token'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients.index'
import { Route as AppClientsIdRouteImport } from './routes/_app/clients.$id'
import { Route as AppProspectsIndexRouteImport } from './routes/_app/prospects.index'
import { Route as AppProspectsIdRouteImport } from './routes/_app/prospects.$id'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings.index'
import { Route as AppSettingsActivityLogRouteImport } from './routes/_app/settings.activity-log'
import { Route as AppSettingsAppearanceRouteImport } from './routes/_app/settings.appearance'
import { Route as AppSettingsAutosearchRouteImport } from './routes/_app/settings.autosearch'
import { Route as AppSettingsBusinessRouteImport } from './routes/_app/settings.business'
import { Route as AppSettingsCollaboratorsRouteImport } from './routes/_app/settings.collaborators'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings.integrations'
import { Route as AppSettingsInvitationsRouteImport } from './routes/_app/settings.invitations'
import { Route as AppSettingsLinkedinRouteImport } from './routes/_app/settings.linkedin'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings.notifications'
import { Route as AppSettingsOrganizationsRouteImport } from './routes/_app/settings.organizations'
import { Route as AppSettingsOrganizationsAgentRouteImport } from './routes/_app/settings.organizations-agent'
import { Route as AppSettingsPrivacyRouteImport } from './routes/_app/settings.privacy'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings.profile'
import { Route as AppSettingsRulesRouteImport } from './routes/_app/settings.rules'
import { Route as AppSettingsSubscriptionRouteImport } from './routes/_app/settings.subscription'
import { Route as AppSettingsTemplatesRouteImport } from './routes/_app/settings.templates'
import { Route as AppWatchesIndexRouteImport } from './routes/_app/watches.index'
import { Route as AppWatchesWatchIdRouteImport } from './routes/_app/watches.$watchId'
import { Route as OwnerOwnerIndexRouteImport } from './routes/_owner/owner.index'
import { Route as OwnerOwnerAiUsageRouteImport } from './routes/_owner/owner.ai-usage'
import { Route as OwnerOwnerBrandingRouteImport } from './routes/_owner/owner.branding'
import { Route as OwnerOwnerEmailTemplatesRouteImport } from './routes/_owner/owner.email-templates'
import { Route as OwnerOwnerEvalRouteImport } from './routes/_owner/owner.eval'
import { Route as OwnerOwnerMetricsRouteImport } from './routes/_owner/owner.metrics'
import { Route as OwnerOwnerPricingRouteImport } from './routes/_owner/owner.pricing'
import { Route as OwnerOwnerSecurityRouteImport } from './routes/_owner/owner.security'
import { Route as OwnerOwnerSeoRouteImport } from './routes/_owner/owner.seo'
import { Route as OwnerOwnerSettingsRouteImport } from './routes/_owner/owner.settings'
import { Route as OwnerOwnerVoiceAgentRouteImport } from './routes/_owner/owner.voice-agent'
import { Route as DocsGroupSlugRouteImport } from './routes/docs.$group.$slug'
import { Route as AppProspectsIdReportRouteImport } from './routes/_app/prospects_.$id.report'
import { Route as OwnerOwnerAnnouncementsIndexRouteImport } from './routes/_owner/owner.announcements.index'
import { Route as OwnerOwnerAnnouncementsNewRouteImport } from './routes/_owner/owner.announcements.new'
import { Route as OwnerOwnerAnnouncementsIdEditRouteImport } from './routes/_owner/owner.announcements.$id.edit'

const Char91indexChar93Route = Char91indexChar93RouteImport.update({
            id: '/index',path: '/index',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const OwnerRoute = OwnerRouteImport.update({
            id: '/_owner',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CollaboratorAcceptRoute = CollaboratorAcceptRouteImport.update({
            id: '/collaborator-accept',path: '/collaborator-accept',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CrmSansAbonnementRoute = CrmSansAbonnementRouteImport.update({
            id: '/crm-sans-abonnement',path: '/crm-sans-abonnement',getParentRoute: () => rootRouteImport
          })
const CrmTpeParisRoute = CrmTpeParisRouteImport.update({
            id: '/crm-tpe-paris',path: '/crm-tpe-paris',getParentRoute: () => rootRouteImport
          })
const LandingRoute = LandingRouteImport.update({
            id: '/landing',path: '/landing',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
            id: '/payment-success',path: '/payment-success',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const UseCasesRoute = UseCasesRouteImport.update({
            id: '/use-cases',path: '/use-cases',getParentRoute: () => rootRouteImport
          })
const Char91indexHtmlChar93Route = Char91indexHtmlChar93RouteImport.update({
            id: '/[index/html]',path: '/[index/html]',getParentRoute: () => rootRouteImport
          })
const AppAgentAuditRoute = AppAgentAuditRouteImport.update({
            id: '/agent-audit',path: '/agent-audit',getParentRoute: () => AppRoute
          })
const AppAgentMetricsRoute = AppAgentMetricsRouteImport.update({
            id: '/agent-metrics',path: '/agent-metrics',getParentRoute: () => AppRoute
          })
const AppAutoSearchRoute = AppAutoSearchRouteImport.update({
            id: '/auto-search',path: '/auto-search',getParentRoute: () => AppRoute
          })
const AppCalendarRoute = AppCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AppRoute
          })
const AppChatRoute = AppChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AppRoute
          })
const AppChecklistsRoute = AppChecklistsRouteImport.update({
            id: '/checklists',path: '/checklists',getParentRoute: () => AppRoute
          })
const AppContactsRoute = AppContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => AppRoute
          })
const AppContentRoute = AppContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => AppRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          })
const AppEmailsRoute = AppEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AppRoute
          })
const AppEventsRoute = AppEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AppRoute
          })
const AppLinkedinHistoryRoute = AppLinkedinHistoryRouteImport.update({
            id: '/linkedin-history',path: '/linkedin-history',getParentRoute: () => AppRoute
          })
const AppMyTasksRoute = AppMyTasksRouteImport.update({
            id: '/my-tasks',path: '/my-tasks',getParentRoute: () => AppRoute
          })
const AppNotificationsRoute = AppNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AppRoute
          })
const AppPersonSearchRoute = AppPersonSearchRouteImport.update({
            id: '/person-search',path: '/person-search',getParentRoute: () => AppRoute
          })
const AppReceiptsRoute = AppReceiptsRouteImport.update({
            id: '/receipts',path: '/receipts',getParentRoute: () => AppRoute
          })
const AppRulesRoute = AppRulesRouteImport.update({
            id: '/rules',path: '/rules',getParentRoute: () => AppRoute
          })
const AppScheduledEmailsRoute = AppScheduledEmailsRouteImport.update({
            id: '/scheduled-emails',path: '/scheduled-emails',getParentRoute: () => AppRoute
          })
const AppSearchRoute = AppSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => AppRoute
          })
const AppSubscriptionRoute = AppSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => AppRoute
          })
const AppTemplatesRoute = AppTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => AppRoute
          })
const AppVeilleRoute = AppVeilleRouteImport.update({
            id: '/veille',path: '/veille',getParentRoute: () => AppRoute
          })
const AppWellbeingRoute = AppWellbeingRouteImport.update({
            id: '/wellbeing',path: '/wellbeing',getParentRoute: () => AppRoute
          })
const AppWhatsNewRoute = AppWhatsNewRouteImport.update({
            id: '/whats-new',path: '/whats-new',getParentRoute: () => AppRoute
          })
const AppWhatsappHistoryRoute = AppWhatsappHistoryRouteImport.update({
            id: '/whatsapp-history',path: '/whatsapp-history',getParentRoute: () => AppRoute
          })
const BookTokenRoute = BookTokenRouteImport.update({
            id: '/book/$token',path: '/book/$token',getParentRoute: () => rootRouteImport
          })
const ComparaisonsIndexRoute = ComparaisonsIndexRouteImport.update({
            id: '/comparaisons/',path: '/comparaisons/',getParentRoute: () => rootRouteImport
          })
const ComparaisonsSlugRoute = ComparaisonsSlugRouteImport.update({
            id: '/comparaisons/$slug',path: '/comparaisons/$slug',getParentRoute: () => rootRouteImport
          })
const DevResponsiveListsRoute = DevResponsiveListsRouteImport.update({
            id: '/dev/responsive-lists',path: '/dev/responsive-lists',getParentRoute: () => rootRouteImport
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/docs/',path: '/docs/',getParentRoute: () => rootRouteImport
          })
const DocsRgpdObligationsRoute = DocsRgpdObligationsRouteImport.update({
            id: '/docs/rgpd-obligations',path: '/docs/rgpd-obligations',getParentRoute: () => rootRouteImport
          })
const EventCheckinCoachIdRoute = EventCheckinCoachIdRouteImport.update({
            id: '/event-checkin/$coachId',path: '/event-checkin/$coachId',getParentRoute: () => rootRouteImport
          })
const OauthAmazonRoute = OauthAmazonRouteImport.update({
            id: '/oauth/amazon',path: '/oauth/amazon',getParentRoute: () => rootRouteImport
          })
const OauthConsentRoute = OauthConsentRouteImport.update({
            id: '/oauth/consent',path: '/oauth/consent',getParentRoute: () => rootRouteImport
          })
const ProspectFormCoachIdRoute = ProspectFormCoachIdRouteImport.update({
            id: '/prospect-form/$coachId',path: '/prospect-form/$coachId',getParentRoute: () => rootRouteImport
          })
const SecurityIndexRoute = SecurityIndexRouteImport.update({
            id: '/security/',path: '/security/',getParentRoute: () => rootRouteImport
          })
const SecurityAiPolicyRoute = SecurityAiPolicyRouteImport.update({
            id: '/security/ai-policy',path: '/security/ai-policy',getParentRoute: () => rootRouteImport
          })
const SecurityAiiaRoute = SecurityAiiaRouteImport.update({
            id: '/security/aiia',path: '/security/aiia',getParentRoute: () => rootRouteImport
          })
const SecurityIncidentProcedureRoute = SecurityIncidentProcedureRouteImport.update({
            id: '/security/incident-procedure',path: '/security/incident-procedure',getParentRoute: () => rootRouteImport
          })
const SecurityPolicyRoute = SecurityPolicyRouteImport.update({
            id: '/security/policy',path: '/security/policy',getParentRoute: () => rootRouteImport
          })
const SecuritySubprocessorsRoute = SecuritySubprocessorsRouteImport.update({
            id: '/security/subprocessors',path: '/security/subprocessors',getParentRoute: () => rootRouteImport
          })
const SharedTokenRoute = SharedTokenRouteImport.update({
            id: '/shared/$token',path: '/shared/$token',getParentRoute: () => rootRouteImport
          })
const TransferTokenRoute = TransferTokenRouteImport.update({
            id: '/transfer/$token',path: '/transfer/$token',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
            id: '/clients/',path: '/clients/',getParentRoute: () => AppRoute
          })
const AppClientsIdRoute = AppClientsIdRouteImport.update({
            id: '/clients/$id',path: '/clients/$id',getParentRoute: () => AppRoute
          })
const AppProspectsIndexRoute = AppProspectsIndexRouteImport.update({
            id: '/prospects/',path: '/prospects/',getParentRoute: () => AppRoute
          })
const AppProspectsIdRoute = AppProspectsIdRouteImport.update({
            id: '/prospects/$id',path: '/prospects/$id',getParentRoute: () => AppRoute
          })
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => AppRoute
          })
const AppSettingsActivityLogRoute = AppSettingsActivityLogRouteImport.update({
            id: '/settings/activity-log',path: '/settings/activity-log',getParentRoute: () => AppRoute
          })
const AppSettingsAppearanceRoute = AppSettingsAppearanceRouteImport.update({
            id: '/settings/appearance',path: '/settings/appearance',getParentRoute: () => AppRoute
          })
const AppSettingsAutosearchRoute = AppSettingsAutosearchRouteImport.update({
            id: '/settings/autosearch',path: '/settings/autosearch',getParentRoute: () => AppRoute
          })
const AppSettingsBusinessRoute = AppSettingsBusinessRouteImport.update({
            id: '/settings/business',path: '/settings/business',getParentRoute: () => AppRoute
          })
const AppSettingsCollaboratorsRoute = AppSettingsCollaboratorsRouteImport.update({
            id: '/settings/collaborators',path: '/settings/collaborators',getParentRoute: () => AppRoute
          })
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
            id: '/settings/integrations',path: '/settings/integrations',getParentRoute: () => AppRoute
          })
const AppSettingsInvitationsRoute = AppSettingsInvitationsRouteImport.update({
            id: '/settings/invitations',path: '/settings/invitations',getParentRoute: () => AppRoute
          })
const AppSettingsLinkedinRoute = AppSettingsLinkedinRouteImport.update({
            id: '/settings/linkedin',path: '/settings/linkedin',getParentRoute: () => AppRoute
          })
const AppSettingsNotificationsRoute = AppSettingsNotificationsRouteImport.update({
            id: '/settings/notifications',path: '/settings/notifications',getParentRoute: () => AppRoute
          })
const AppSettingsOrganizationsRoute = AppSettingsOrganizationsRouteImport.update({
            id: '/settings/organizations',path: '/settings/organizations',getParentRoute: () => AppRoute
          })
const AppSettingsOrganizationsAgentRoute = AppSettingsOrganizationsAgentRouteImport.update({
            id: '/settings/organizations-agent',path: '/settings/organizations-agent',getParentRoute: () => AppRoute
          })
const AppSettingsPrivacyRoute = AppSettingsPrivacyRouteImport.update({
            id: '/settings/privacy',path: '/settings/privacy',getParentRoute: () => AppRoute
          })
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
            id: '/settings/profile',path: '/settings/profile',getParentRoute: () => AppRoute
          })
const AppSettingsRulesRoute = AppSettingsRulesRouteImport.update({
            id: '/settings/rules',path: '/settings/rules',getParentRoute: () => AppRoute
          })
const AppSettingsSubscriptionRoute = AppSettingsSubscriptionRouteImport.update({
            id: '/settings/subscription',path: '/settings/subscription',getParentRoute: () => AppRoute
          })
const AppSettingsTemplatesRoute = AppSettingsTemplatesRouteImport.update({
            id: '/settings/templates',path: '/settings/templates',getParentRoute: () => AppRoute
          })
const AppWatchesIndexRoute = AppWatchesIndexRouteImport.update({
            id: '/watches/',path: '/watches/',getParentRoute: () => AppRoute
          })
const AppWatchesWatchIdRoute = AppWatchesWatchIdRouteImport.update({
            id: '/watches/$watchId',path: '/watches/$watchId',getParentRoute: () => AppRoute
          })
const OwnerOwnerIndexRoute = OwnerOwnerIndexRouteImport.update({
            id: '/owner/',path: '/owner/',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerAiUsageRoute = OwnerOwnerAiUsageRouteImport.update({
            id: '/owner/ai-usage',path: '/owner/ai-usage',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerBrandingRoute = OwnerOwnerBrandingRouteImport.update({
            id: '/owner/branding',path: '/owner/branding',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerEmailTemplatesRoute = OwnerOwnerEmailTemplatesRouteImport.update({
            id: '/owner/email-templates',path: '/owner/email-templates',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerEvalRoute = OwnerOwnerEvalRouteImport.update({
            id: '/owner/eval',path: '/owner/eval',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerMetricsRoute = OwnerOwnerMetricsRouteImport.update({
            id: '/owner/metrics',path: '/owner/metrics',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerPricingRoute = OwnerOwnerPricingRouteImport.update({
            id: '/owner/pricing',path: '/owner/pricing',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerSecurityRoute = OwnerOwnerSecurityRouteImport.update({
            id: '/owner/security',path: '/owner/security',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerSeoRoute = OwnerOwnerSeoRouteImport.update({
            id: '/owner/seo',path: '/owner/seo',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerSettingsRoute = OwnerOwnerSettingsRouteImport.update({
            id: '/owner/settings',path: '/owner/settings',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerVoiceAgentRoute = OwnerOwnerVoiceAgentRouteImport.update({
            id: '/owner/voice-agent',path: '/owner/voice-agent',getParentRoute: () => OwnerRoute
          })
const DocsGroupSlugRoute = DocsGroupSlugRouteImport.update({
            id: '/docs/$group/$slug',path: '/docs/$group/$slug',getParentRoute: () => rootRouteImport
          })
const AppProspectsIdReportRoute = AppProspectsIdReportRouteImport.update({
            id: '/prospects_/$id/report',path: '/prospects/$id/report',getParentRoute: () => AppRoute
          })
const OwnerOwnerAnnouncementsIndexRoute = OwnerOwnerAnnouncementsIndexRouteImport.update({
            id: '/owner/announcements/',path: '/owner/announcements/',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerAnnouncementsNewRoute = OwnerOwnerAnnouncementsNewRouteImport.update({
            id: '/owner/announcements/new',path: '/owner/announcements/new',getParentRoute: () => OwnerRoute
          })
const OwnerOwnerAnnouncementsIdEditRoute = OwnerOwnerAnnouncementsIdEditRouteImport.update({
            id: '/owner/announcements/$id/edit',path: '/owner/announcements/$id/edit',getParentRoute: () => OwnerRoute
          })





const AppRouteChildren = {
  AppAgentAuditRoute: AppAgentAuditRoute,AppAgentMetricsRoute: AppAgentMetricsRoute,AppAutoSearchRoute: AppAutoSearchRoute,AppCalendarRoute: AppCalendarRoute,AppChatRoute: AppChatRoute,AppChecklistsRoute: AppChecklistsRoute,AppContactsRoute: AppContactsRoute,AppContentRoute: AppContentRoute,AppDashboardRoute: AppDashboardRoute,AppEmailsRoute: AppEmailsRoute,AppEventsRoute: AppEventsRoute,AppLinkedinHistoryRoute: AppLinkedinHistoryRoute,AppMyTasksRoute: AppMyTasksRoute,AppNotificationsRoute: AppNotificationsRoute,AppPersonSearchRoute: AppPersonSearchRoute,AppReceiptsRoute: AppReceiptsRoute,AppRulesRoute: AppRulesRoute,AppScheduledEmailsRoute: AppScheduledEmailsRoute,AppSearchRoute: AppSearchRoute,AppSubscriptionRoute: AppSubscriptionRoute,AppTemplatesRoute: AppTemplatesRoute,AppVeilleRoute: AppVeilleRoute,AppWellbeingRoute: AppWellbeingRoute,AppWhatsNewRoute: AppWhatsNewRoute,AppWhatsappHistoryRoute: AppWhatsappHistoryRoute,AppClientsIdRoute: AppClientsIdRoute,AppProspectsIdRoute: AppProspectsIdRoute,AppSettingsActivityLogRoute: AppSettingsActivityLogRoute,AppSettingsAppearanceRoute: AppSettingsAppearanceRoute,AppSettingsAutosearchRoute: AppSettingsAutosearchRoute,AppSettingsBusinessRoute: AppSettingsBusinessRoute,AppSettingsCollaboratorsRoute: AppSettingsCollaboratorsRoute,AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,AppSettingsInvitationsRoute: AppSettingsInvitationsRoute,AppSettingsLinkedinRoute: AppSettingsLinkedinRoute,AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,AppSettingsOrganizationsRoute: AppSettingsOrganizationsRoute,AppSettingsOrganizationsAgentRoute: AppSettingsOrganizationsAgentRoute,AppSettingsPrivacyRoute: AppSettingsPrivacyRoute,AppSettingsProfileRoute: AppSettingsProfileRoute,AppSettingsRulesRoute: AppSettingsRulesRoute,AppSettingsSubscriptionRoute: AppSettingsSubscriptionRoute,AppSettingsTemplatesRoute: AppSettingsTemplatesRoute,AppWatchesWatchIdRoute: AppWatchesWatchIdRoute,AppClientsIndexRoute: AppClientsIndexRoute,AppProspectsIndexRoute: AppProspectsIndexRoute,AppSettingsIndexRoute: AppSettingsIndexRoute,AppWatchesIndexRoute: AppWatchesIndexRoute,AppProspectsIdReportRoute: AppProspectsIdReportRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const OwnerRouteChildren = {
  OwnerOwnerAiUsageRoute: OwnerOwnerAiUsageRoute,OwnerOwnerBrandingRoute: OwnerOwnerBrandingRoute,OwnerOwnerEmailTemplatesRoute: OwnerOwnerEmailTemplatesRoute,OwnerOwnerEvalRoute: OwnerOwnerEvalRoute,OwnerOwnerMetricsRoute: OwnerOwnerMetricsRoute,OwnerOwnerPricingRoute: OwnerOwnerPricingRoute,OwnerOwnerSecurityRoute: OwnerOwnerSecurityRoute,OwnerOwnerSeoRoute: OwnerOwnerSeoRoute,OwnerOwnerSettingsRoute: OwnerOwnerSettingsRoute,OwnerOwnerVoiceAgentRoute: OwnerOwnerVoiceAgentRoute,OwnerOwnerIndexRoute: OwnerOwnerIndexRoute,OwnerOwnerAnnouncementsNewRoute: OwnerOwnerAnnouncementsNewRoute,OwnerOwnerAnnouncementsIndexRoute: OwnerOwnerAnnouncementsIndexRoute,OwnerOwnerAnnouncementsIdEditRoute: OwnerOwnerAnnouncementsIdEditRoute
}

const OwnerRouteWithChildren = OwnerRoute._addFileChildren(OwnerRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AppRoute: AppRouteWithChildren,OwnerRoute: OwnerRouteWithChildren,AuthRoute: AuthRoute,CollaboratorAcceptRoute: CollaboratorAcceptRoute,ContactRoute: ContactRoute,CrmSansAbonnementRoute: CrmSansAbonnementRoute,CrmTpeParisRoute: CrmTpeParisRoute,Char91indexChar93Route: Char91indexChar93Route,LandingRoute: LandingRoute,LegalRoute: LegalRoute,OnboardingRoute: OnboardingRoute,PaymentSuccessRoute: PaymentSuccessRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,UseCasesRoute: UseCasesRoute,Char91indexHtmlChar93Route: Char91indexHtmlChar93Route,BookTokenRoute: BookTokenRoute,ComparaisonsSlugRoute: ComparaisonsSlugRoute,DevResponsiveListsRoute: DevResponsiveListsRoute,DocsRgpdObligationsRoute: DocsRgpdObligationsRoute,EventCheckinCoachIdRoute: EventCheckinCoachIdRoute,OauthAmazonRoute: OauthAmazonRoute,OauthConsentRoute: OauthConsentRoute,ProspectFormCoachIdRoute: ProspectFormCoachIdRoute,SecurityAiPolicyRoute: SecurityAiPolicyRoute,SecurityAiiaRoute: SecurityAiiaRoute,SecurityIncidentProcedureRoute: SecurityIncidentProcedureRoute,SecurityPolicyRoute: SecurityPolicyRoute,SecuritySubprocessorsRoute: SecuritySubprocessorsRoute,SharedTokenRoute: SharedTokenRoute,TransferTokenRoute: TransferTokenRoute,ComparaisonsIndexRoute: ComparaisonsIndexRoute,DocsIndexRoute: DocsIndexRoute,SecurityIndexRoute: SecurityIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,DocsGroupSlugRoute: DocsGroupSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)